import PolygonBase from './PolygonBase';
import shapeRoundRect from '../assets/icons/shapeRoundRect.svg';
import { svgToIcon } from '../utils/svg';
import { roundRectEdgePathString } from './utils';
class ShapeRoundRect extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeRoundRect);
  }

  static pathString(r = 0.15) {
    return roundRectEdgePathString(r);
  }
}

export default ShapeRoundRect;
